export enum StatusReserveAccount {
	EMPTY = 'empty', // заявка отправлена без ДРС
	LATER = 'later', // заявка отправлена без ДРС, но затем пользователь передумал и создал ДРС
	IN_WORK = 'in_work', // заявка с ДРС
}
